import { Transaction } from '@elastic/apm-rum';
import { withTransaction } from '@elastic/apm-rum-react';
import hoistStatics from 'hoist-non-react-statics';
import React from 'react';
import { useLocation } from 'react-router-dom';

const withRouteChange = (name?: string) => (Component: React.ComponentType) => {
  let RouteChangeComponent: React.FC<{ transaction?: Transaction }> = (props) => {
    const location = useLocation();

    if (props.transaction) {
      props.transaction.name = location.pathname;
    }

    return <Component {...props} />;
  };

  RouteChangeComponent.displayName = `withRouteChange(${Component.displayName || Component.name})`;

  RouteChangeComponent = hoistStatics(RouteChangeComponent, Component);

  return withTransaction(name ?? Component.displayName, 'route-change', () =>
    console.log('withRouteChange', Component.displayName)
  )(RouteChangeComponent);
};

export default withRouteChange;
